import curriculumTemplates from './curriculumTemplates';
import resultTypesTemplates from './resultTypesTemplates';
import gradeTables from './gradeTables';

export { curriculumTemplates, resultTypesTemplates, gradeTables };
